import { render } from "./SubscriptionOffers.page.vue?vue&type=template&id=58f6c800"
import script from "./SubscriptionOffers.page.vue?vue&type=script&lang=js"
export * from "./SubscriptionOffers.page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__